/**
 * 工具箱
 */
const index = () => import(/* webpackChunkName: "group-toolkit" */ '../view/toolkit/Index.vue');
const stopwordIndex = () => import(/* webpackChunkName: "group-toolkit" */ '../view/stopword/Index');
const stopwordText = () => import(/* webpackChunkName: "group-toolkit" */ '../view/stopword/Text');
const stopwordSingle = () => import(/* webpackChunkName: "group-toolkit" */ '../view/stopword/Single');
const stopwordAll = () => import(/* webpackChunkName: "group-toolkit" */ '../view/stopword/All');
const xenu = () => import(/* webpackChunkName: "group-toolkit" */ '../view/xenu/Index.vue');
const densityIndex = () => import(/* webpackChunkName: "group-toolkit" */ '../view/density/Index.vue');
const density = () => import(/* webpackChunkName: "group-toolkit" */ '../view/density/seach.vue');
const densityList = () => import(/* webpackChunkName: "group-toolkit" */ '../view/density/list.vue');
export default [
    {
        path: '/toolkit',
        name: 'toolkit',
        component: index,
        meta: {
            title: '【旋涡营销】广告禁用词，死链检测工具',
            keywords: '广告违禁词，广告禁用词，敏感词检测，禁用词检测,死链接检测',
            description: '旋涡营销老板工具为企业提供广告禁用词检测和死链检测功能，为企业规避违反广告法风险，减少网站跳出率'
        }
    },
    {
        path: '/stopword',
        name: 'stopword',
        component: stopwordIndex,
        meta: {
            title: '【旋涡营销】-广告法禁用词'
        }
    },
    {
        path: '/stopword-text',
        name: 'stopword-text',
        component: stopwordText,
        meta: {
            title: '【旋涡营销】-广告法禁用词'
        }
    },
    {
        path: '/stopword-single',
        name: 'stopword-single',
        component: stopwordSingle,
        meta: {
            title: '【旋涡营销】-广告法禁用词'
        }
    },
    {
        path: '/stopword-all',
        name: 'stopword-all',
        component: stopwordAll,
        meta: {
            title: '【旋涡营销】-广告法禁用词'
        }
    },
    {
        path: '/xenu',
        name: 'xenu',
        component: xenu,
        meta: {
            title: '【旋涡营销】-死链检测'
        }
    },
    {
        path: '/densityIndex',
        name: 'densityIndex',
        component: densityIndex,
        children: [
            {
                path: '/',
                name: 'density',
                component: density,
                meta: {
                    title: '【旋涡营销】收录查询工具',
                    keepAlive:true
                }
            },
            {
                path: 'densityList',
                name: 'densityList',
                component: densityList,
                meta: {
                    title: '【旋涡营销】-关键词密度查询'
                }
            }
        ]

    },

]



// WEBPACK FOOTER //
// ./app/router/router-toolkit.js